import { ChevronRight } from "lucide-react";
import Link from "next/link";

interface GlossaryCardProps {
	id: string;
	title: string;
	description: string;
	slug: string;
}

const GlossaryCard = ({ id, title, description, slug }: GlossaryCardProps) => {
	return (
		<Link href={`/glossary/${slug}`}>
			<div
				className="flex cursor-pointer flex-col gap-1 rounded-xl border px-4 py-3 transition-all hover:ring-4 hover:ring-slate-50 sm:gap-1 lg:rounded-2xl lg:px-6 lg:py-5 dark:bg-slate-900/20 dark:hover:ring-slate-700"
				key={id}
			>
				<h3 className="font-medium text-xl capitalize lg:text-lg">{title}</h3>

				<p className="hidden lg:line-clamp-3">{description}</p>

				<button className="mt-1 hidden max-w-max items-center font-medium text-sky-600 hover:underline lg:flex dark:text-sky-300">
					<span>Read More</span> <ChevronRight size={20} />
				</button>
			</div>
		</Link>
	);
};

export default GlossaryCard;
